import React from 'react'
import Layout from '../components/Layout'

const Index = () => (
  <Layout>
    <h1>Home</h1>
    <p>
      <a href="https://svg-perf.vercel.app">SVG version</a>
    </p>
  </Layout>
)

export default Index
